import { mergeAll, compose, concat } from 'ramda';

export const pick = (orig, keys) =>
    keys.reduce((acc, key) => ({ ...acc, [key]: orig[key] }), {});

export const normalizeNumber = (value, prevValue) => {
    const convertedValue = Number(value);

    if (value === '') return;

    if (Number.isNaN(convertedValue)) {
        const currentValue = Number(prevValue);

        return Number.isNaN(currentValue) ? '' : currentValue;
    }

    return convertedValue;
};

// Not sure why this broke, adding ts-ignore for now 
// @ts-ignore
export const mergeRules = compose(mergeAll, concat);

export const formatToUsd = (value) => {
    const normalizedValue = +String(value).replace(/[^0-9.]/g, '');
    if (isNaN(normalizedValue)) {
        return value;
    }

    return new Intl.NumberFormat('us-US', {
        style: 'currency',
        currency: 'USD',
        minimumSignificantDigits: 2,
        maximumSignificantDigits: 3,
        // @ts-ignore
        notation: 'compact',
    }).format(normalizedValue);
};

export type Noop = () => void | undefined;
export const noop: Noop | undefined = () => {};
